import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateTileForm = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = p('nameFieldEmpty');
  }
  if (!values.description) {
    errors.description = p('descriptionFieldCantBeEmpty');
  }
  if (!values.subtitle) {
    errors.subtitle = p('subTitleFieldCantBeEmpty');
  }

  if (!values.endDate) {
    errors.endDate = p('endDateFieldCantBeEmpty');
  }
  if (
    values.showPriceMeter &&
    (!values.planDesiredValue ||
      Number.isNaN(values.planDesiredValue) ||
      Number(values.planDesiredValue) <= 0)
  ) {
    errors.planDesiredValue = p('planDesiredValueFieldCantBeEmpty');
  }
  if (!values.goal1 || Number.isNaN(values.goal1) || Number(values.goal1) < 1) {
    errors.goal1 = p('goalFieldCantBeEmpty');
  }
  if (!values.goal2 || Number.isNaN(values.goal2) || Number(values.goal2) < 1) {
    errors.goal2 = p('goalFieldCantBeEmpty');
  }
  if (!values.goal3 || Number.isNaN(values.goal3) || Number(values.goal3) < 1) {
    errors.goal3 = p('goalFieldCantBeEmpty');
  }
  const popularAmounts = values.popularAmounts?.map(Number);
  if (
    !popularAmounts?.length ||
    popularAmounts.some((amount) => Number.isNaN(amount) || amount < 1)
  ) {
    errors.popularAmounts = { _error: p('popularAmountsFieldCantBeEmpty') };
  }
  if (
    !values.amountStep ||
    Number.isNaN(values.amountStep) ||
    Number(values.amountStep) < 1
  ) {
    errors.amountStep = p('amountStepFieldCantBeEmpty');
  }
  if (
    !values.amountMin ||
    Number.isNaN(values.amountMin) ||
    Number(values.amountMin) < 1
  ) {
    errors.amountMin = p('amountMinFieldCantBeEmpty');
  }
  if (!values.scoreType) {
    errors.scoreType = p('scoreTypeFieldCantBeEmpty');
  }
  if (
    !values.goalCapPerGameStep ||
    Number.isNaN(values.goalCapPerGameStep) ||
    Number(values.goalCapPerGameStep) < 1
  ) {
    errors.goalCapPerGameStep = p('goalCapPerGameStepFieldCantBeEmpty');
  }
  return errors;
};
export default validateTileForm;
